import { GridColDef as IMuiGridColDef } from '@mui/x-data-grid/models/colDef/gridColDef';
import { Box, Button, Link as MuiLink, Tooltip, Typography } from '@mui/material';
import { ReportGrid } from '@tap/mui-ui/src/XGridTable/ReportGrid';
import { IComponentCss, numberHelper, getGeneratedDynamicLink } from '@tap/mui-ui';
import { IssueStatisticOnWorkersReportResult, userService } from '@tap/data-providers';
import { Link } from 'react-router';
import { RoutesData } from '../../../routes/routes';

/*
*   Таблица Статистика по исполнителям для заявок
*/

// Цвета для ячеек со значениями
const css: IComponentCss = {
    tableWrap: {
        position: 'relative',
        height: 'calc(100vh - 125px)',
        width: 1,
        '& .table-wrap.is-value': {
            backgroundColor: '#FBDBB5',
            borderBottomColor: '#FBDBB5',
        },
        '& .table-wrap.is-red-value': {
            backgroundColor: '#FFBDBD',
            borderBottomColor: '#FFBDBD',
        },
    },
    optionsButton: {
        zIndex: 1,
        position: 'absolute',
        right: '4px',
        top: '5px',
        height: '28px',
    },
};

// Столбцы и их параметры
const getColumns = (reportData: IssueStatisticOnWorkersReportResult): IMuiGridColDef<any, any, any>[] => {

    return ([
        {
            // Задача
            field: 'documentKey',
            headerName: 'Заявка',
            headerAlign: 'left',
            align: 'left',
            flex: 1,
            sortable: false,
            renderCell: (cellParams) => (
                <>
                    <MuiLink
                        component={Link}
                        to={getGeneratedDynamicLink(
                            RoutesData.detailsPageRoutes.path,
                            [{ key: 'documentKey', value: cellParams.row.documentKey }],
                        )}
                    >
                        {cellParams.row.documentKey}
                    </MuiLink>
                    <Typography sx={{ marginLeft: '5px' }}>{cellParams.row.title}</Typography>
                </>
            ),
        },
        {
            // Название
            field: 'title',
            headerName: 'Название',
            type: 'string',
            sortable: false,
            hide: true,
        },
        ...((reportData?.stat || []).map(el => {
            return {
                // Исполнители
                field: el.worker.id.toString(),
                headerName: userService.getUserFIO(el.worker) || '-',
                renderHeader: () => <Tooltip title={`#${el.worker.tabNum}`}>
                    <div className='MuiDataGrid-columnHeaderTitle'>
                        {userService.getUserFIO(el.worker)}
                    </div>
                </Tooltip >,
                width: el.worker.lastName.length * 11 || 70,
                sortable: false,
                type: 'number' as const,
                valueGetter: (_val, row) => numberHelper.formatNumberWithDotDelimiter(row[el.worker.id] / 60, 2),
                renderCell: (cellParams: any) => cellParams.row[el.worker.id]
                    ? `${numberHelper.formatNumberWithDotDelimiter(cellParams.row[el.worker.id] / 60, 2)} ч`
                    : '-',
            }
        })),
        {
            // Затрачено
            field: 'totalSpentMin',
            headerName: 'Итого',
            headerAlign: 'right',
            align: 'right',
            type: 'number',
            sortable: false,
            valueGetter: (_val, row) => numberHelper.formatNumberWithDotDelimiter(row.totalSpentMin / 60, 2),
            renderCell: (cellParams) => cellParams.row.totalSpentMin || cellParams.row.totalSpentMin === 0
                ? `${numberHelper.formatNumberWithDotDelimiter(cellParams.row.totalSpentMin / 60, 2)} ч`
                : '-',
        },
    ])
}

type IssueStatisticOnWorkersReportTableProps = {
    reportData: IssueStatisticOnWorkersReportResult,
    onOptionsButtonClick: () => void,
}

const getRowsList = (reportData: IssueStatisticOnWorkersReportResult) => {
    if (!reportData?.rows) return [];

    return reportData.rows.map((row, idx) => {
        return {
            ...row,
            ...row.workers,
            id: idx,
        }
    })
}

export default function IssueStatisticOnWorkersReportTable({ reportData, onOptionsButtonClick }: IssueStatisticOnWorkersReportTableProps) {

    const rowList = getRowsList(reportData);

    return (
        <>
            {/* Таблица */}

            <Box sx={css.tableWrap}>
                <Button
                    size='small'
                    sx={css.optionsButton}
                    onClick={onOptionsButtonClick}
                >
                    Параметры отчёта
                </Button>

                <ReportGrid
                    columns={getColumns(reportData)}
                    rows={rowList}
                    tableProps={{
                        rowHeight: 22,
                        initialState: {
                            pinnedColumns: {
                                left: ['documentKey'],
                                right: ['totalSpentMin'],
                            },
                        },
                    }}
                />
            </Box>
        </>
    );
}
